<template>
  <li class="border-b-[1px] border-solid border-gray-light last:border-b-0">
    <router-link
      :to="{ name: to }"
      :exact="false"
      class="group block w-full p-2 font-regular text-gray-90"
      :class="{
        'bg-turquoise-10': isActive(to) > 0
      }"
      active-class="bg-turquoise-10">
      <span v-html="text" class="p-2 px-4 w-full block rounded-[4px] group-hover:bg-turquoise-10"></span>
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'NavLink',
  props: {
    to: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  methods: {
    isActive(to) {
      return this.$route.path.indexOf(this.getName(to))
    },
    getName(val) {
      if(val == "ErrorReports")
        return 'felanmalan'
      else return val;
    }
  }
};
</script>
